<template>
    <rkm-modal
        extra-large
        persistent
        ref="RkmModal"
        title="Encaminhamento"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.modulosEncaminhamento"
                        :validations="validations.moduloEncaminhamento"
                        @change="handleModuloEncaminhamentoChange"
                        label="Módulo"
                        show-default-option
                        text-field="nome"
                        v-model="model.moduloEncaminhamentoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.centrosCustoEncaminhamento"
                        :validations="validations.centroCustoEncaminhamento"
                        @change="handleCentroCustoEncaminhamentoChange"
                        label="Setor"
                        show-default-option
                        text-field="setorNome"
                        v-model="model.centroCustoEncaminhamentoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.opcoesEntradaEncaminhamento"
                        :validations="validations.opcaoEntradaEncaminhamento"
                        label="Opção de entrada"
                        show-default-option
                        text-field="nome"
                        v-model="model.opcaoEntradaEncaminhamentoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.prioridades"
                        :validations="validations.prioridade"
                        label="Prioridade"
                        show-default-option
                        text-field="nome"
                        v-model="model.prioridadeId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({loading: 'getLoading'}),
        validations() {
            return {
                moduloEncaminhamento: {required: true},
                centroCustoEncaminhamento: {required: true},
                opcaoEntradaEncaminhamento: {required: true},
                prioridade: {
                    required: !!this.model.opcaoEntradaEncaminhamentoId
                        && !!this.form.opcoesEntradaEncaminhamento
                            .find(oe => oe.id === this.model.opcaoEntradaEncaminhamentoId).prioridadeObrigatoria
                },
            }
        },
    },
    created() {
        this.repositories = {
            filaAtendimento: this.getConectaSusRepository('painelSenha.filaAtendimento'),
        }
    },
    data: () => ({
        fila: null,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(fila) {
            this.fila = fila

            this.reset()
            this.create()

            this.$refs.RkmModal.show()
        },
        create() {
            this.setLoading()

            this.repositories.filaAtendimento.createEncaminhamento(this.fila.id)
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleModuloEncaminhamentoChange() {
            this.form.centrosCustoEncaminhamento = []
            this.model.centroCustoEncaminhamentoId = null
            this.form.opcoesEntradaEncaminhamento = []
            this.model.opcaoEntradaEncaminhamentoId = null

            if (!this.model.moduloEncaminhamentoId) return

            const request = {
                listar: 'centros-custo-encaminhamento',
                opcaoEntradaOrigemId: this.fila.opcaoEntradaDestinoId ?? this.fila.opcaoEntradaId,
                moduloId: this.model.moduloEncaminhamentoId,
            }

            this.setLoading()

            this.repositories.filaAtendimento.listEncaminhamento(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.centrosCustoEncaminhamento = Object.assign(response.data.centrosCustoEncaminhamento)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleCentroCustoEncaminhamentoChange() {
            this.form.opcoesEntradaEncaminhamento = []
            this.model.opcaoEntradaEncaminhamentoId = null

            if (!this.model.centroCustoEncaminhamentoId) return

            const request = {
                listar: 'opcoes-entrada-encaminhamento',
                opcaoEntradaOrigemId: this.fila.opcaoEntradaDestinoId ?? this.fila.opcaoEntradaId,
                moduloId: this.model.moduloEncaminhamentoId,
                centroCustoId: this.model.centroCustoEncaminhamentoId,
            }

            this.setLoading()

            this.repositories.filaAtendimento.listEncaminhamento(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.opcoesEntradaEncaminhamento = Object.assign(response.data.opcoesEntradaEncaminhamento)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form = null
            this.model = null
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (!valid) return

                    this.setLoading()

                    const request = this.camelObjectKeysToSnakeRecursive({
                        opcaoEntradaEncaminhamentoId: this.model.opcaoEntradaEncaminhamentoId,
                        prioridadeId: this.model.prioridadeId,
                    })

                    this.repositories.filaAtendimento.forward(this.fila.id, request)
                        .then(() => {
                            this.showSaveNotification()
                            this.$refs.RkmModal.hide()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },

    },
    mixins: [error, repository, stringCase],
}
</script>